import { AutogenModelDrs401kHist, AutogenRowDrs401kHist } from "./autogen/AutogenModelDrs401kHist";

export class ModelDrs401kHist extends AutogenModelDrs401kHist<RowDrs401kHist> {
	constructor() {
		super(RowDrs401kHist);
	}
}

export class RowDrs401kHist extends AutogenRowDrs401kHist {
}